import React, { createContext, useCallback, useContext, useState } from "react";

/**
 * Global drawer for "Suggest a Product" — used when a shopper can't find
 * what they need in the catalogue and wants Dyntra's sourcing team to
 * either stock the item or send them a link to a comparable SKU.
 *
 * Any component with a "Suggest a Product" affordance calls
 * `openSuggestProduct({ product, category, query })` and can optionally
 * pass the last searched term / category so the shopper doesn't have to
 * re-type context.
 */

const SuggestProductDrawerContext = createContext(null);

const EMPTY_PREFILL = {
  product: "",
  category: "",
  query: "",
};

export function SuggestProductDrawerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState(EMPTY_PREFILL);

  const openSuggestProduct = useCallback((next = {}) => {
    setPrefill({ ...EMPTY_PREFILL, ...next });
    setOpen(true);
  }, []);

  const closeSuggestProduct = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <SuggestProductDrawerContext.Provider
      value={{ open, prefill, openSuggestProduct, closeSuggestProduct }}
    >
      {children}
    </SuggestProductDrawerContext.Provider>
  );
}

export function useSuggestProductDrawer() {
  const ctx = useContext(SuggestProductDrawerContext);
  if (!ctx) {
    return {
      open: false,
      prefill: EMPTY_PREFILL,
      openSuggestProduct: () => {},
      closeSuggestProduct: () => {},
    };
  }
  return ctx;
}
